<template>
  <div class="card assets-offline-map-filter">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">FILTER ASSETS</p>
    </header>
    <div class="card-content loading-container" :style="{ height: `${height}px` }">
      <b-loading :is-full-page="false" :active="loading" />
      <b-field label="SAP ID">
        <b-input v-model="filters.thirdPartyCode"></b-input>
      </b-field>
      <b-field label="ORDER NUMBER">
        <b-input v-model="filters.advanced.orderNumber"></b-input>
      </b-field>
      <b-field>
        <b-checkbox v-model="filters.hotspot" type="is-dark">Hotspot Only</b-checkbox>
      </b-field>
      <ul class="menu-list">
        <li>
          <b-checkbox type="is-dark" @input="onCbAssetTypesInput" v-model="checkboxes.assetTypes">
            <b>ASSET TYPES</b>
          </b-checkbox>
        </li>
        <li>
          <ul class="menu-list">
            <li>
              <b-field v-for="assetType in assetTypes" :key="assetType.id">
                <b-checkbox
                  v-model="filters.assetTypes"
                  :native-value="assetType.id"
                  type="is-dark"
                >{{ assetType.name }}</b-checkbox>
              </b-field>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <footer class="card-footer">
      <b-button class="is-fullwidth" :loading="filtering" @click="filter">APPLY FILTER</b-button>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    mapHeight: {
      type: Number,
      default: 500
    },
    assetTypes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    filters: {
      thirdPartyCode: '',
      advanced: {},
      assetTypes: []
    },
    checkboxes: {
      assetTypes: false
    }
  }),
  computed: {
    height() {
      return this.mapHeight + 12 - 20;
    }
  },
  watch: {
    assetTypes(assetTypes) {
      this.checkAllAssetTypes();
      this.filter();

      this.checkboxes.assetTypes =
        this.filters.assetTypes.length === this.assetTypes.length;
    },
    "filters.assetTypes"(val) {
      this.checkboxes.assetTypes = val.length === this.assetTypes.length;
    }
  },
  methods: {
    filter() {
      this.$emit("filter", JSON.parse(JSON.stringify(this.filters)));
    },
    checkAllAssetTypes() {
      this.filters.assetTypes = this.assetTypes.map(type => type.id);
    },
    onCbAssetTypesInput(val) {
      if (val) {
        this.checkAllAssetTypes();
      } else {
        this.filters.assetTypes = [];
      }
    }
  }
};
</script>

<style lang="scss">
.assets-offline-map-filter {
  .loading-container {
    position: relative;

    .loading-overlay {
      z-index: 1;
    }
  }
  .card-content {
    overflow-y: scroll;
  }
  .card-content:hover {
    &::-webkit-scrollbar-thumb {
      background: #ccc;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #888;
    }
  }
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 25px;
  }
  .card-footer {
    border-top: none;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapFilter.vue